document.querySelectorAll('.js-hamburger-trigger').forEach((el) => {
  el.addEventListener('click', () => {
    document.body.classList.toggle('is-open');
  });
});

document.querySelectorAll('.js-hamburger-menu-close').forEach((el) => {
  el.addEventListener('click', () => {
    document.body.classList.remove('is-open');
  });
});
